import type { MultiPolygon, Polygon } from 'geojson';

/** Approximate polygon area in m² (validation only, not persisted). */
export function computePolygonAreaSqM(geometry: Polygon | MultiPolygon): number {
  if (geometry.type === 'MultiPolygon') {
    return geometry.coordinates.reduce((sum, poly) => sum + ringAreaSqM(poly[0]), 0);
  }
  return ringAreaSqM(geometry.coordinates[0]);
}

function ringAreaSqM(ring: number[][]): number {
  if (ring.length < 4) return 0;
  const latMid = ring.reduce((s, p) => s + p[1], 0) / ring.length;
  const mPerDegLat = 111_320;
  const mPerDegLng = 111_320 * Math.cos((latMid * Math.PI) / 180);
  let area = 0;
  for (let i = 0; i < ring.length - 1; i++) {
    const x1 = ring[i][0] * mPerDegLng;
    const y1 = ring[i][1] * mPerDegLat;
    const x2 = ring[i + 1][0] * mPerDegLng;
    const y2 = ring[i + 1][1] * mPerDegLat;
    area += x1 * y2 - x2 * y1;
  }
  return Math.abs(area / 2);
}

export function formatAreaLabel(sqM: number): string {
  if (sqM >= 10_000) return `${(sqM / 10_000).toFixed(2)} ha`;
  if (sqM >= 1_000) return `${(sqM / 1_000).toFixed(1)}k m²`;
  return `${Math.round(sqM)} m²`;
}
